import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TabContainer,
  // TopInfoWrapper,

} from '../../styles'
import { Button, Input, TopProgress, Select, Toggle } from '../../../../components'
import { icons } from '../../../../icons'
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useAuth } from '../../../../context/user.context'
import { authService } from '../../../../api'
import { useUi } from '../../../../context/ui.context'
import { useUi as useUiContext } from '../../../../context/ui.context'

const MyProfile:FC = () => {
  const [t] = useTranslation()
  const { themeDark, setThemeDark } = useUiContext()
  const [user, setUser] = useState<any>({})
  const {viewAlert} = useUi()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [initialValues, setInitialValues ] = useState<any>({
    first_name:user.first_name,
    last_name:user.last_name,
    email:user.email,
    phone:user.mobile_phone_number,
    language: localStorage.getItem('lang') || 'uk',
    old_password:'',
    password:'',
    password_confirm:'',
  })
  const languageOptions = [
    { id: 'en', title: t("ENGLISH") },
    { id: 'uk', title: t("UKRAINE") },
  ]
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const onSubmit = (values:any) => {
    const data = {
      first_name:values.first_name,
      last_name:values.last_name,
      email:values.email,
      mobile_phone_number:values.phone,
      language: values.language,
      old_password: values.old_password,
      password: values.password,
      password_confirm: values.password_confirm,
    }
    setLoading(true)
    authService.updateClient(data)
      .then(() => authService.getUserProfile())
      .then((res) => {
    setLoadingComplete(true)
    setTimeout(() => {
      setLoading(false)
      setLoadingComplete(false)
      const updatedUser = {
        ...res.data.user,
        mobile_phone_number: res.data.user.mobile_phone_number || '',
      }
      const languageChanged = updatedUser.language !== user.language;
      setUser(updatedUser)
      setInitialValues({
        first_name:updatedUser.first_name,
        last_name:updatedUser.last_name,
        email:updatedUser.email,
        phone:updatedUser.mobile_phone_number || '',
        language: updatedUser.language || values.language,
        old_password:'',
        password:'',
        password_confirm:'',
      })
      if(values.language){
        localStorage.setItem('lang', values.language)
      }
      if (languageChanged) {
        window.location.reload();
      }
    },1000)
  })
      .catch((e => {
        if(e.response?.data?.detail){
          viewAlert({
            severity:'error',
            message:e.response.data.detail,
          })
        }
        if(e.response?.data?.mobile_phone_number){
          viewAlert({
            severity:'error',
            message:e.response.data.mobile_phone_number,
          })
        }
        setErrors(e.response?.data || {})
        setLoading(false)
      }))
  }

  useEffect(() => {
    authService.getUserProfile()
    .then((res) => {
      setUser({...res.data.user, mobile_phone_number:res.data.user.mobile_phone_number || ''})
      setInitialValues({
        first_name:res.data.user.first_name,
        last_name:res.data.user.last_name,
        email:res.data.user.email,
        phone:res.data.user.mobile_phone_number || '',
        language: res.data.user.language || localStorage.getItem('lang') || 'uk',
        old_password:'',
        password:'',
        password_confirm:'',
      })
    })
    .catch((e) => {
      if(e.response.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      } 
    })
    .finally(() => setPageLoading(false))
  },[])
  
  const {
    values,
    errors,
    touched,
    setErrors,
    setFieldValue,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      first_name: yup.string().required(`${t("REQUIRED_FIELD")}`),
      last_name: yup.string().required(`${t("REQUIRED_FIELD")}`),
      email: yup.string().email(`${t("NOT_VALID_EMAIL")}`).required(`${t("REQUIRED_FIELD")}`),
      phone: yup.string(),
      language: yup.string().required(`${t("REQUIRED_FIELD")}`),
      old_password: yup.string(),
      password: yup.string(),
      password_confirm: yup.string().oneOf([yup.ref('password'), null], t("PASSWORDS_MATCH_ERROR")),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  const isUnchanged =
    (user?.email || '') === (values.email || '') &&
    (user?.first_name || '') === (values.first_name || '') &&
    (user?.last_name || '') === (values.last_name || '') &&
    (user?.mobile_phone_number || '') === (values.phone || '') &&
    (user?.language || '') === (values.language || '') &&
    !values.password &&
    !values.password_confirm &&
    !values.old_password;

  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <TabContainer>
      <div style={{width:'360px', display:'flex', gap:'20px', flexDirection:'column'}}>
        <Input
          fieldName='first_name'
          title={t("FIRST_NAME")}
          placeholder=''
          {...formikProps}
        />
        <Input
          fieldName='last_name'
          title={t("LAST_NAME")}
          placeholder=''
          {...formikProps}
        />
        <Input
          fieldName='email'
          title={t("EMAIL_ADDRESS")}
          placeholder=''
          {...formikProps}
        />
        <Input
          fieldName='phone'
          title={t("PHONE_NUMBER")}
          placeholder=''
          {...formikProps}
        />
        <Select
          title={t("LANGUAGE")}
          data={languageOptions}
          selectedValue={values.language}
          onChange={(val:any) => setFieldValue('language', val?.id || val)}
        />
        <Toggle
          title={t("DARK_THEME")}
          value={themeDark}
          onChange={() => setThemeDark(!themeDark)}
        />
        <Input
          fieldName='old_password'
          title={t("CURRENT_PASSWORD")}
          placeholder=''
          isPassword
          {...formikProps}
        />
        <Input
          fieldName='password'
          title={t("NEW_PASSWORD")}
          placeholder=''
          isPassword
          {...formikProps}
        />
        <Input
          fieldName='password_confirm'
          title={t("PASSWORD_CONFIRM")}
          placeholder=''
          isPassword
          {...formikProps}
        />
      </div>
      <Button
        variant='primary'
        disabled={isUnchanged}
        size='display'
        loading={loading}
        loadingComplete={loadingComplete}
        onClick={handleSubmit}
        customStyles={{marginTop:'24px'}}
        title={t("SAVE")}
        // icon={icons.Filter}
      />

    </TabContainer>
  )
}
export default MyProfile
